import { AppointmentRequestStatus } from 'apps/wrapper/src/services/appointment/types/appointment-request-status';
import { ApptRequestVerificationSummary } from 'apps/wrapper/src/services/insurance/types/appt-request-verification-summary';
import { PatientVerificationSummary } from 'apps/wrapper/src/services/insurance/types/patient-verification-summary';
import { createContext } from 'react';

export interface ApptRequestsIvContextProps {
  apptRequestIvSummaries: ApptRequestVerificationSummary[];
  patientIvSummaries: PatientVerificationSummary[];
  ivStatusesToProcess: AppointmentRequestStatus[];
  isLoadingIv: boolean;
}

export const ApptRequestsIvContext = createContext<ApptRequestsIvContextProps>(null!);
